<p-dropdown
  [options]="roles"
  [(ngModel)]="selectedRole"
  (ngModelChange)="selectedRoleChanged()"
  optionLabel="title"
  placeholder="Seleccionar rol"
></p-dropdown>
